export const RewardManagerV2Events = {
  GetTotalPendingRewards: 'RewardManagerV2.GetTotalPendingRewards',
  TotalPendingRewardsReturned: 'RewardManagerV2.TotalPendingRewardsReturned',

  ClaimRewardInBatch: 'RewardManagerV2.ClaimRewardInBatch',
  ClaimRewardInBatchCompleted: 'RewardManagerV2.ClaimRewardInBatchCompleted',
}
